import React from 'react';
import { resendGift } from '../VoucherDetail/VoucherOrderDetailApi';
import * as PATH from '../../../lib/routes/path';
import { Flex } from '../../../components/common/atom/Layout';
import { BorderButton } from './OrderResultButton';
import { VOUCHER_ORDER_CANCEL_STATUS } from '../Status/OrderStatus';

const VoucherOrderResultButton = ({ id, item }) => {
  const { id: voucherOrderId, additionalInfo: voucherOrderInfo, status } = item;

  const isPresentOrder =
    status === 'PAID' && voucherOrderInfo.recipientName !== null;

  const handleResendGift = () => {
    if (window.confirm('재전송을 하시겠습니까?') === true) {
      resendGift({ voucherOrderId, voucherOrderInfo });
    }
  };

  return (
    <>
      {VOUCHER_ORDER_CANCEL_STATUS.includes(status) && (
        <Flex justifyContent="space-around">
          <BorderButton
            size={14}
            color="brownGrey"
            link={`${PATH.MYPAGE_ORDER_REFUND}/${id}`}
          >
            주문취소
          </BorderButton>
          {isPresentOrder && (
            <BorderButton
              size={14}
              color="brownGrey"
              onClick={() => handleResendGift()}
              link={PATH.MYPAGE_ORDER}
            >
              다시전송
            </BorderButton>
          )}
        </Flex>
      )}
    </>
  );
};

export default React.memo(VoucherOrderResultButton);
